import React from 'react';
import get from 'lodash/get';
import { useIntl } from 'react-intl-next';
import { DatePicker } from '@atlaskit/datetime-picker';
import { fg } from '@atlaskit/platform-feature-flags';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { isMobile } from '../../../../jira-common/utils/native/detectDeviceType';
import { DEFAULT_WEEK_START_DAY, getLocale } from '../../../utils/localeUtils';
import { ShortFieldWrapper } from '../common/questionWrappers';
import { DatePickerMobile } from '../mobile/DatePickerMobile';
import { EditDateMessages, IntlEditDateMessages } from './EditDateMessages.intl';
export var EditDate = function EditDate(_ref) {
  var id = _ref.id,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  var intl = useIntl();
  var startOfWeekDay = get(getLocale(intl.locale), 'options.weekStartsOn', DEFAULT_WEEK_START_DAY);
  return isMobile() && !fg('proforma_use_atlaskit_date_time_picker_for_mobile') ? /*#__PURE__*/React.createElement(DatePickerMobile, {
    dateValue: value,
    onChange: onChange
  }) : /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(DatePicker, {
    id: id,
    value: value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    locale: intl.locale || DEFAULT_LOCALE,
    placeholder: intl.formatMessage(IntlEditDateMessages[EditDateMessages.DatePlaceholder], {
      date: intl.formatDate(new Date(), {})
    }),
    weekStartDay: startOfWeekDay,
    label: label,
    shouldShowCalendarButton: fg('dst-init-calendar-button-proforma-editdate') ? true : undefined
  }));
};